import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { MOCK_USER_CONTEXT } from "./user-context.mock";
import { UserContext } from "./user-context.model";

/**
 * Provides the current user context (sales organizations, profile).
 * Currently returns mock data.
 * TODO: Replace with real HTTP call to the User Service once available.
 */
@Injectable({ providedIn: "root" })
export class UserContextClient {
  loadUserContext(): Observable<UserContext> {
    return of(MOCK_USER_CONTEXT);
  }
}
